var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52 7.44016L5.57333 8.38683C5.02464 7.83824 4.61544 7.16614 4.38 6.42683L5.67333 6.10016C5.88667 6.6935 6.18667 7.10016 6.52 7.44016ZM7.33333 4.00016L4.66667 1.3335L2 4.00016H4.01333C4.02667 4.54016 4.06667 5.02683 4.14 5.44683L5.43333 5.12016C5.38667 4.80016 5.35333 4.42016 5.34667 4.00016H7.33333ZM14 4.00016L11.3333 1.3335L8.66667 4.00016H10.66C10.5933 6.4535 9.80667 7.16683 8.96667 7.92016C8.63333 8.2135 8.29333 8.5335 8 8.9535C7.77333 8.62683 7.51333 8.36683 7.24667 8.12683L6.30667 9.06683C6.92667 9.6335 7.33333 10.0935 7.33333 11.3335V14.6668H8.66667V11.3335C8.66667 9.98683 9.14 9.56016 9.86 8.9135C10.78 8.08683 11.9133 7.06016 11.9933 4.00016H14Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuse);
export default __webpack_public_path__ + "static/media/muse.daa7ebd91021783124a572d9ea53c13e.svg";
export { ForwardRef as ReactComponent };